import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "./BookCategoryPage.css";
import Header from "../Header";
import SideBar from "../Sidebar";
import useWindowWidth from "../../utils/windowWidth";
import BookShelf from "../../pages/BookShelf/BookShelf";
import back from "../../assets/back.svg";
import { REACT_APP_SHRAVAN_BASE_URL } from "../../utils/constants";


function BookCategoryPage() {

  const { language } = useParams();
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("Hindi");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [shelf, setShelf] = useState(false);

  // Fetch categories on component mount
  useEffect(() => {
    if (language) {
      setSelectedLanguage(language);
    }

    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${REACT_APP_SHRAVAN_BASE_URL}/categories/${selectedLanguage}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        let data = response.data;
        data = data.slice(5);
        setCategories([...data,'Nclude Books','Telangana Books']);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryClick = (category) => {
    localStorage.setItem("currentCategory", category);
  };

  const handleLanguageChange = async (event) => {
    const lang = event.target.value;
    setSelectedLanguage(lang);
    localStorage.setItem("currentLanguage", lang);
  };

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="">
      {!isMobile && <Header activePage="lib" curr={0} setShelf={setShelf} />}
      <div className="page-container">
        <SideBar activePage="Library" />
        {isMobile && <header className="mobile-header">
      <div className="accessibility-header" id="accessibility-menu" tabIndex={-1}>
        <div tabIndex={0} onClick={()=> setShelf(false)} className={shelf?"":"active-accessibility-header"}>{'Browse All Books'}</div>
        <div tabIndex={0} onClick={()=> setShelf(true)} className={shelf?"active-accessibility-header":""}>Book Shelf</div>
      </div>  
    </header>}
        <div className="doc-container" role="main" tabIndex={-1} style={{ paddingTop: isMobile?"2rem":""}}>
          {shelf && <BookShelf />}
          {!shelf && (
            <div>
              <section className="header-wrap d-flex justify-content-start align-items-center">
                <div className="w-100">
                  {/* <div
                    style={{
                      color: "#5030E5",
                      cursor: "pointer",
                      fontSize: "16px",
                      gap: "0.2rem",
                    }}
                    role="button"
                    className="d-flex single-article"
                    onClick={() => navigate(-1)}
                  >
                    <img src={back} alt="back-button" />
                    Back
                  </div> */}
                  <h1 className="logo my-auto mt-5 ">
                    <span className="">
                      Nclude Audiobooks Library
                    </span>
                  </h1>

                  <header>
                    <div
                      className="w-full h-fit mt-20 flex flex-col md:flex-row-reverse justify-between gap-5"
                    >
                      <div className="newsDropdownContainers w-full md:w-auto">
                        <div className="input-div-search">
                          <h2 id="output-format" className="form-label sr-only">
                            Select Language
                          </h2>
                          <select
                            className="form-control input-6 w-full md:w-auto"
                            id="language"
                            name="language"
                            aria-label="Select Language"
                            value={selectedLanguage}
                            onChange={(event) => {
                              const lang = event.target.value;
                              localStorage.setItem("currentLanguage", lang);
                              setSelectedLanguage(lang);
                            }}
                            aria-labelledby="language"
                            required
                          >
                            <option key="english" value="English">English</option>
                            {/* <option key="hindi" value="Hindi">Hindi</option> */}
                            {/* <option key="telugu" value="Telugu">Telugu</option> */}
                          </select>
                        </div>
                      </div>
                      <div className="flex category-header">
                        <h2>Choose one book category</h2>
                      </div>
                    </div>
                  </header>
                </div>
              </section>
              <div className="d-flex flex-column justify-content-center align-items-start category-container">
                {/* <div className="d-flex flex-row flex-wrap justify-content-end align-items-center w-100">
                  <h2 className="me-3 my-auto text-left language-font">
                    Select a language
                  </h2>
                  <select
                    className="form-select w-auto"
                    value={selectedLanguage}
                    onChange={handleLanguageChange}
                  >
                    <option key="hindi" value="Hindi">
                      Hindi
                    </option>
                    <option key="english" value="English">
                      English
                    </option>
                  </select>
                </div> */}

                <div className="d-flex flex-row flex-wrap justify-content-between align-items-center w-100 component-container">
                  <div
                    className="container card-container"
                    style={{
                      padding: "20px",
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    {/* <div className='container card-container' style={{ padding: '20px', textAlign: 'center',width:'100%' }}>

                </div> */}
                    {/* <h2 className="me-3 text-left">Choose one book category</h2> */}

                    <div className="category-list w-100">
                      {categories.map((cat, idx) => (
                        <div key={idx} className="category-item book-category">
                          <Link
                            to={`/category/${selectedLanguage}/books/${cat}`}
                            onClick={() => {
                              handleCategoryClick(cat);
                            }}
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            <div className="result-data d-flex justify-content-start align-items-baseline">
                              <p className="mb-0">
                                {idx + 1}. {cat}
                              </p>
                            </div>
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              {loading && <p>Loading books...</p>}
              {error && <p style={{ color: "red" }}>Error: {error}</p>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default BookCategoryPage;
